import React, { useState } from 'react'
import { Content } from './style'
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'
import { TypeMainOutlet } from '..'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'
import { Header } from '../../../components/SubHeaderFilter/types'
import { PageHeader } from '../../../components/StandardPage'

export const serviceHeaders: Header[] = [
  { key: 'name', label: 'Serviço', type: 'string' },
  { key: 'code', label: 'Código', type: 'string' },
  { key: 'area', label: 'Área', type: 'string' },
  { key: 'sector', label: 'Setor', type: 'string' },
  { key: 'category', label: 'Categoria', type: 'string' },
  { key: 'type', label: 'Tipo', type: 'string' },
  { key: 'suppliers', label: 'Fornecedor', type: 'string' },
  { key: 'machines', label: 'Máquinas', type: 'string' },
  {
    key: 'prices',
    label: 'Preço',
    type: 'price',
    unitOptions: [
      { value: 'Dia', label: 'Dia' },
      { value: 'Hora', label: 'Hora' },
      { value: 'UN', label: 'Unidade' },
    ],
  },
  { key: 'markup', label: 'Markup', type: 'number' },
  { key: 'description', label: 'Descrição detalhada', type: 'string' },
  { key: 'observation', label: 'Observações', type: 'string' },
  { key: 'deadlineInDays', label: 'Prazo', type: 'number' },
  { key: 'executionTime', label: 'Tempo execução', type: 'time' },
  { key: 'setupTime', label: 'Tempo setup', type: 'time' }
]

const ServicesContent = () => {
  const { search } = useOutletContext<TypeMainOutlet>()
  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const servicesFiltersState = usePersistedFilters('services')

  const outletContext = React.useMemo(() => ({
    search,
    refresh,
    setIsLoading,
    isLoading,
    appliedFilters: servicesFiltersState.appliedFilters
  }), [search, refresh, isLoading, servicesFiltersState.appliedFilters])

  return (
    <>
      <PageHeader
        title='Serviços'
        tableName='Stage'
        moduleName='Serviços'
        onReload={() => setRefresh(prev => !prev)}
        isLoading={isLoading}
        filterHeaders={serviceHeaders}
        onApplyFilter={servicesFiltersState.handleApplyFilter}
        appliedFilters={servicesFiltersState.appliedFilters}
        onRemoveFilter={servicesFiltersState.handleRemoveFilter}
        onClearAllFilters={servicesFiltersState.handleClearAll}
        createButton={{ label: 'Novo serviço', onClick: () => navigate('create') }}
      />
      <Content>
        <Outlet context={outletContext}/>
      </Content>
    </>
  )
}

export default ServicesContent

